import {lazy, Suspense} from "react";
import CircularLoader from "../../customs/loader/main";


const Main = lazy(() => import("../../components/application/changeOfName/main"));

const ChangeOfName = () => {

    return(

        <Suspense fallback={<CircularLoader/>}>
            <Main/>
        </Suspense>
      
    )
};

export default ChangeOfName;